import {gql, useQuery} from "@apollo/client";
import Card from "../../../components/card/Card";
import {
    Box,
    Button,
    Flex,
    Heading,
    Icon,
    Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Spacer,
    Spinner,
    StackDivider,
    Text,
    Tooltip, useDisclosure,
    VStack
} from "@chakra-ui/react";
import {useLocationQuery} from "../../admin/products/analyze"
import StarRatings from 'react-star-ratings';
import {FiArrowLeft} from "react-icons/fi"
import Highlighter from "react-highlight-words";
import {BsCircleFill, BsStar} from "react-icons/bs";
import {indexColorMap} from "../../admin/products/analyze/SentimentSelectorButton";
import {monthToText} from "../../admin/products/analyze/ReviewReader";
import {NavLink as ReactLink} from "react-router-dom";
import {escapeRegex} from "../../../utils/stringUtils"
import React, {useState} from "react";
import {capitalizeFirstLetter} from "../../../utils/stringUtils";
import {AppleAppStoreLogo, PlayStoreLogo} from "../../../components/icons/Icons";
import {ChevronDownIcon} from "@chakra-ui/icons";


const GetThemeTopics = gql`
query GetThemeTopics($customer: String = "", $theme_id: Int!) {
  themes_by_pk(customer: $customer, theme_id: $theme_id) {
    theme_name
    enabled
    topics {
      topic_id
      topic_name
    }
  }
}`

const GetTopicReasonTexts = gql`
query GetTopicReasonTexts($customer: String = "", $topic_ids: [Int!]) {
  topics(where: {topic_id: {_in: $topic_ids}, customer: {_eq: $customer}}) {
    theme_id
    topic_id
    topic_name
    topic_definitions {
      query
      topic_id
      semantic_sentiments(order_by: {text: {timestamp_original: desc}}) {
        sentiment
        text {
          text
          timestamp_original
          rating: data(path: "$.review_rating")
          product {
            platform
          }
        }
      }
      query_to_aspect_sentiment(order_by: {text: {timestamp_original: desc}}, where: {customer: {_eq: $customer}}) {
        sentiment
        aspect
        text {
          timestamp_original
          text
          product {
            platform
          }
          rating: data(path: "$.review_rating")
          reasons {
            reason_text
            term
          }
        }
      }
      ai_solutions {
        solution
      }
    }
  }
}

`

export const GetThemeTextStatistics = gql`
query GetThemeTextStatistics($interval_days: Int, $theme_id_arg: Int, $customer_name: String) {
  theme_text_statistics_fn_fn_fn(args: {interval_days: $interval_days, theme_id_arg: $theme_id_arg, customer_name: $customer_name}) {
    avg_rating
    count
    interval_count
    negatives
    neutrals
    positives
  }
}
`

function getReasonByTerm({reasonArr, term}) {
    if (reasonArr === null) return ""
    for (let obj of reasonArr) {
        if (obj.term === term) {
            return obj.reason_text
        }
    }
    return ""
}

function getIconForPlatform(platform) {
    switch (platform) {
        case "google_play_store":
            return <Tooltip label='Google Play Store'><PlayStoreLogo mr="5px"/></Tooltip>
        case "apple_app_store":
            return <Tooltip label="Apple App Store"><AppleAppStoreLogo mr="5px"/></Tooltip>
        default:
            return <Icon/>
    }
}

function TopicDefGrid({topic_ids, sentimentFilter}) {
    const dummyIndex = {"positive": 0, "neutral": 1, "negative": 2}
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [solutionText, setSolutionText] = useState("")
    const [solutionTopicDef, setSolutionTopicDef] = useState("")
    let {loading, error, data: topicData} = useQuery(GetTopicReasonTexts,
        {
            variables: {"topic_ids": topic_ids, "customer": localStorage.getItem("customerName")}
        }
    )
    if (error) console.log("GetTopicReasonTexts query failed", error)
    if (loading) return <Spinner size='lg' ml="400px" mt="300px"/>

    function openModal(solution, topicDef) {
        let solution_list = solution.split(/\r?\n/)
        let htmlsolution = <VStack>{solution_list.map((item, index) => {
            return <Text key={index} size='20px' fontWeight='500' lineHeight='30px'
                         color='rgba(0, 0, 0, 0.9)'>{item}</Text>
        })
        }</VStack>
        setSolutionText(htmlsolution)
        setSolutionTopicDef(topicDef)
        onOpen()
    }

    console.log("topicData", topicData)
    return (
        <>
            <Flex flexDirection="column" mx="5px">
                <VStack divider={<StackDivider borderColor='#000000E5'/>}>
                    {topicData.topics.map((topic) => topic.topic_definitions.map((def) =>
                        <> <Flex flexDirection="row" w="97%"><Text size='20px' fontWeight='500' lineHeight='30px'
                                                                   pos='absolute' left={'60%'}
                                                                   color='rgba(0, 0, 0, 0.9)'>{capitalizeFirstLetter(def.query)}</Text>
                            <Button bgColor={"#F1F1F1"} borderRadius={"5px"} ml="auto" size="sm" mb={"1px"}
                                    onClick={() => openModal(def.ai_solutions[0]?.solution ?? "No solution found", capitalizeFirstLetter(def.query))}>Solutions</Button></Flex>
                            <Flex flexDirection='column' maxH="350px" overflowY="auto" w="97%">
                                {def.query_to_aspect_sentiment.concat(def.semantic_sentiments).filter(item => sentimentFilter === "All" ? true : item.sentiment === sentimentFilter.toLowerCase()).map((item, index) => {
                                    const d = new Date(item.text.timestamp_original);
                                    return (
                                        <Box mb="5px" bgColor={index % 2 === 0 ? '#F1F1F1' : '#FFFFFF'}>
                                            <Highlighter searchWords={[escapeRegex(getReasonByTerm({
                                                reasonArr: item.text.reasons ?? null,
                                                term: def.query
                                            }))]}
                                                         highlightStyle={{
                                                             "background-color": "rgba(255, 193, 47, 0.25)",
                                                             "border-radius": "5px",
                                                             "padding": "0px 3px"
                                                         }}
                                                         textToHighlight={item.text.text}/>
                                            <Box key={index.toString() + def.query} px="6px">
                                                <Flex verticalAlign="bottom" alignItems="center">
                                                    {getIconForPlatform(item.text.product.platform)}
                                                    <BsStar/><Text
                                                    fontWeight="bold" ml="2px">{item.text.rating}</Text>
                                                    <Text
                                                        ml="15px">{' ' + d.getDate() + ' ' + monthToText[d.getMonth()] + ' ' + d.getFullYear()}
                                                    </Text>
                                                    <Spacer/>
                                                    <BsCircleFill style={{
                                                        color: indexColorMap[dummyIndex[item.sentiment]],
                                                        size: "0.8em",
                                                        height: "0.8em",
                                                        width: "0.8em",
                                                        marginLeft: "10px"
                                                    }}/>
                                                </Flex>
                                            </Box>
                                        </Box>
                                    )
                                })
                                }
                            </Flex></>
                    ))}
                </VStack>
            </Flex>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>Solutions for {solutionTopicDef}</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        {solutionText}
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

function ThemeOrTopicStatistics({themeId}) {

    let {loading, error, data} = useQuery(GetThemeTextStatistics,
        {
            variables: {
                "theme_id_arg": themeId,
                "interval_days": 30,
                "customer_name": localStorage.getItem("customerName")
            }
        }
    )
    if (error) console.log("GetThemeTextStatistics query failed", error)
    if (loading) return <Spinner size='lg' ml="40px" mt="30px"/>
    const positiveSentiment = Number((data.theme_text_statistics_fn_fn_fn[0].positives * 100 /
        (data.theme_text_statistics_fn_fn_fn[0].positives + data.theme_text_statistics_fn_fn_fn[0].negatives +
            data.theme_text_statistics_fn_fn_fn[0].neutrals)).toFixed(0))
    const negativeSentiment = Number((data.theme_text_statistics_fn_fn_fn[0].negatives * 100 /
        (data.theme_text_statistics_fn_fn_fn[0].positives + data.theme_text_statistics_fn_fn_fn[0].negatives +
            data.theme_text_statistics_fn_fn_fn[0].neutrals)).toFixed(0))
    console.log("negativeSentiment", negativeSentiment, "positiveSentiment", positiveSentiment)
    const negativeX = 0.495 * (100 - negativeSentiment)
    const negativeWidth = negativeSentiment * 0.495
    const positiveWidth = positiveSentiment * 0.495
    const positiveX = 50.5
    return (
        <Flex flexDirection='column' w="220px">
            <Heading size='xs' mt="15px">Sentiment</Heading>
            <svg width='100%' height='14px'>
                <g className='bars'>
                    <rect x='0%' y='2px' fill='#F1F1F1' width='100%' height='10px'/>

                    <rect fill='#FC8181' x={`${negativeX}%`} y='2px' width={`${negativeWidth}%`}
                          height='10px'/>
                    <rect fill='#68D391' x={`${positiveX}%`} y='2px' width={`${positiveWidth}%`}
                          height='10px'/>
                    <rect fill='#000000' x="49.5%" y="0px" width="1%" height="14px"/>
                </g>
            </svg>
            <Flex flexDirection='row'>
                <Flex flexDirection='column' ml="25px">
                    <Heading size='xs'>NEGATIVE</Heading>
                    <Flex flexDirection='row' alignItems='baseline'>
                        <Text fontSize='2xl'>{negativeSentiment}%</Text>
                        {/*<Text>% -21%</Text>*/}
                    </Flex>
                </Flex>
                <Flex flexDirection='column' ml="50px">
                    <Heading size='xs'>POSITIVE</Heading>
                    <Flex flexDirection='row' alignItems='baseline'>
                        <Text fontSize='2xl'>{positiveSentiment}%</Text>
                        {/*<Text>% +15%</Text>*/}
                    </Flex>
                </Flex>
            </Flex>
            <Heading size='xs' mt="15px">Activity (1 month)</Heading>
            <Flex flexDirection='row' alignItems='baseline'>
                <Text fontSize='2xl'>{data.theme_text_statistics_fn_fn_fn[0].count}</Text>
                <Text> +{data.theme_text_statistics_fn_fn_fn[0].interval_count}</Text>
            </Flex>
            <Heading size='xs' mt="15px">User Ratings</Heading>
            <StarRatings
                rating={data?.theme_text_statistics_fn_fn_fn[0]?.avg_rating ? data?.theme_text_statistics_fn_fn_fn[0]?.avg_rating : 0}
                starRatedColor="#7CB4F5"
                starDimension='20px'
                starSpacing='4px'
                numberOfStars={5}
                name='rating'
            />
        </Flex>
    )
}

function ThemeTopicComponent({topics, themeName, themeId}) {
    const [selectedTopic, setSelectedTopic] = useState({topic_id: "Select All"});
    const [sentimentFilter, setSentimentFilter] = useState("All");
    const dummyIndex = {"Positive": 0, "Neutral": 1, "Negative": 2}
    console.log("selectedTopic", selectedTopic)

    return (

        <Card w='90%' py='5px' px='20px' ml='48px' mt="20px" mb="20px">
            <Flex flexDirection="row" alignItems='center' gap='10px' mb="10px"> {/* Heading */}
                <Link to={`/home/themes/`} as={ReactLink}>
                    <FiArrowLeft size="24px" color="#F46818"/> </Link>
                <Heading size='lg'>{themeName}</Heading>
                <Spacer/>
                <Menu>
                    <MenuButton as={Button} rightIcon={<ChevronDownIcon/>} borderRadius='md'
                                borderWidth='1px' variant='outline'>
                        <Flex flexDirection={'row'}> {sentimentFilter} Sentiment{sentimentFilter !== 'All' ?
                            <BsCircleFill
                                style={{
                                    color: indexColorMap[dummyIndex[sentimentFilter]],
                                    size: "0.8em",
                                    height: "0.8em",
                                    width: "0.8em",
                                    marginLeft: "10px"
                                }}/> : null}
                        </Flex>
                    </MenuButton>
                    <MenuList>
                        <MenuItem onClick={() => setSentimentFilter("All")}>All Sentiment</MenuItem>
                        <MenuItem onClick={() => setSentimentFilter("Positive")}>Positive Sentiment<BsCircleFill
                            style={{
                                color: indexColorMap[dummyIndex["Positive"]],
                                size: "0.8em",
                                height: "0.8em",
                                width: "0.8em",
                                marginLeft: "10px"
                            }}/></MenuItem>
                        <MenuItem onClick={() => setSentimentFilter("Negative")}>Negative Sentiment<BsCircleFill
                            style={{
                                color: indexColorMap[dummyIndex["Negative"]],
                                size: "0.8em",
                                height: "0.8em",
                                width: "0.8em",
                                marginLeft: "10px"
                            }}/></MenuItem>
                        <MenuItem onClick={() => setSentimentFilter("Neutral")}>Neutral Sentiment<BsCircleFill style={{
                            color: indexColorMap[dummyIndex["Neutral"]],
                            size: "0.8em",
                            height: "0.8em",
                            width: "0.8em",
                            marginLeft: "10px"
                        }}/></MenuItem>
                    </MenuList>
                </Menu>
            </Flex>
            <Flex flexDirection='column'>
                <Flex flexDirection='row'>
                    <ThemeOrTopicStatistics themeId={themeId}/>
                    <Flex flexDirection='column'>
                        <Heading size='lg'>Topics</Heading>
                        {/*Write a vertical selector in react */}
                        <VStack alignItems="flex-start" p='10px' gap='10px' w='250px' borderRadius='10px' mt="20px"
                                bgColor='#F1F1F1'>
                            <Flex flexDirection='row' py='2px' px='10px' gap='10px' h='26px' borderRadius='5px'
                                  bgColor={selectedTopic.topic_id === "Select All" ? '#000000' : null} w='230px'
                                  onClick={() => setSelectedTopic({topic_id: "Select All"})}
                                  _hover={{cursor: "pointer"}}>
                                <Text
                                    color={selectedTopic.topic_id === "Select All" ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.9)'}
                                    fontSize='16px' fontWeight='400'
                                    lineHeight='22px'>Select All</Text>
                            </Flex>
                            {topics.map((topic) => (
                                <Flex flexDirection='row' py='2px' px='10px' gap='10px' h='26px' borderRadius='5px'
                                      bgColor={selectedTopic.topic_id === topic.topic_id ? '#000000' : null} w='230px'
                                      onClick={() => setSelectedTopic(topic)} _hover={{cursor: "pointer"}}
                                      key={topic.topic_id}>
                                    <Text
                                        color={selectedTopic.topic_id === topic.topic_id ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.9)'}
                                        fontSize='16px' fontWeight='400'
                                        lineHeight='22px'>{topic.topic_name}</Text>
                                </Flex>))}
                        </VStack>
                    </Flex>
                    <Flex>
                        <TopicDefGrid
                            topic_ids={selectedTopic.topic_id === "Select All" ? topics.map((topic) => topic.topic_id) : [selectedTopic.topic_id]}
                            sentimentFilter={sentimentFilter}/>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    )
}

export default function ThemeTopicsPage() {
    let query = useLocationQuery();

    const themeId = query.get('theme_id');
    let {loading, error, data: themeData} = useQuery(GetThemeTopics,
        {
            variables: {"theme_id": themeId, "customer": localStorage.getItem("customerName")}
        }
    )
    if (error) console.log("GetThemeReasonTexts query failed", error)
    if (loading) return <Spinner size='lg' ml="400px" mt="300px"/>
    console.log("themeTopicData", themeData)
    const themeName = themeData.themes_by_pk.theme_name;
    const topics = themeData.themes_by_pk.topics;

    return (
        <ThemeTopicComponent topics={topics} themeName={themeName} themeId={themeId}/>
    )
}